import { Typography } from "@mui/material";

//implement the 404 page
const Page404 = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <Typography variant="h1">404 - Page Not Found</Typography>
    </div>
  );
};

export default Page404;
